export default __webpack_public_path__ + "static/media/register_worker.a9b29e8a.png";